module.exports = __webpack_public_path__ + "img/title-lp-text-mobile.6af3976.svg";